import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from './Header';
import Footer from './Footer';

const PetDetails = () => {
    const { id } = useParams();
    const [petData, setpetData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPetDetail = async () => {
            try {
                const response = await fetch(`https://petcrew.in/app-admin/api/pets.php?type=details&petid=${id}`);
                const text = await response.text();
                console.log("Raw Response Text:", text);
    
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
    
                const data = JSON.parse(text);
                console.log("Parsed Data:", data);
    
                if (data.Error === "False" && data.Data && data.Data.pet_details) {
                    // Merge pet_details and first image (if available)
                    const combinedData = {
                        ...data.Data.pet_details,
                        image_link: data.Data.pet_image?.[0] || "",
                        images: data.Data.pet_image || []
                    };
                    setpetData(combinedData);
                } else {
                    throw new Error(data.Message || "No pet data available");
                }
            } catch (err) {
                console.error("Error Fetching pet Detail:", err);
                setError(err.message || "Unknown error");
            } finally {
                setLoading(false);
            }
        };
    
        fetchPetDetail();
    }, [id]);
    

    if (loading) return <p>Loading pet details...</p>;
    if (error) return <p>Error: {error}</p>;
    if (!petData) return <p>No pet data available.</p>;

    return (
        <>
            <Header />
            <div style={styles.container} className="pet-detail-container">
  <div style={styles.categoryBadge}>Dog Breed</div>

  <h1 style={styles.title}>{petData.title}</h1>
  <h2 style={styles.subtitle}>{petData.subtitle}</h2>

  <div style={styles.meta}>
    <span><strong>Location:</strong> {petData.location}, {petData.city}, {petData.state}, {petData.country} - {petData.pincode}</span><br />
    <span><strong>Created On:</strong> {petData.created_on || 'N/A'}</span><br />
    <span><strong>Last Updated:</strong> {petData.updated_on || 'N/A'}</span>
  </div>

  <div style={styles.imageContainer}>
    {petData.images && petData.images.map((img, index) => (
      <img
        key={index}
        src={img}
        alt={`${petData.title || "Pet"} image ${index + 1}`}
        style={{ ...styles.image, marginBottom: "10px" }}
      />
    ))}
  </div>

  <div style={styles.content}>
    <p style={{ whiteSpace: 'pre-line' }}>{petData.sort_desc}</p>
  </div>
</div>

            <Footer />
        </>
    );
};

const styles = {
    container: {
        maxWidth: "800px",
        margin: "0 auto",
        padding: "20px",
        fontFamily: "'Arial', sans-serif",
        lineHeight: "1.6",
        color: "#333",
    },
    categoryBadge: {
        display: "inline-block",
        backgroundColor: "#4caf50",
        color: "#fff",
        padding: "5px 10px",
        borderRadius: "5px",
        fontSize: "14px",
        marginBottom: "10px",
    },
    title: {
        fontSize: "28px",
        fontWeight: "bold",
        marginBottom: "10px",
    },
    meta: {
        fontSize: "14px",
        color: "#777",
        marginBottom: "20px",
    },
    imageContainer: {
        textAlign: "center",
        marginBottom: "20px",
        display: "flex",
    justifyContent: "center",
    gap: "20px",
    },
    image: {
        width: "250px",
        height: "250px",
        
    },
    content: {
        fontSize: "16px",
    },
};

export default PetDetails;
